import React, { Component } from "react";
import { Spring, animated } from "react-spring";

export default class ShakeEffect extends Component {
  shake = {
    from: { x: 0 },
    to: [
      { x: 30 },
      { x: -30 },
      { x: 25 },
      { x: -25 },
      { x: 15 },
      { x: -15 },
      { x: 5 },
      { x: -5 },
      { x: 0 },
    ],
    config: {
      duration: 100,
    },
  };

  state = {
    isError: false,
  };

  setIsError = () => {
    this.setState({ isError: true }, () => this.setState({ isError: false }));
  };

  render() {
    const { children } = this.props;
    return (
      <Spring {...(this.state.isError ? this.shake : {})}>
        {(shakeStyle) => {
          return (
            <animated.div style={shakeStyle}>
              {children(this.setIsError)}
            </animated.div>
          );
        }}
      </Spring>
    );
  }
}
